import { render } from "./ForumThreadCreate.vue?vue&type=template&id=3792d7ae&scoped=true"
import script from "./ForumThreadCreate.vue?vue&type=script&lang=js"
export * from "./ForumThreadCreate.vue?vue&type=script&lang=js"

import "./ForumThreadCreate.vue?vue&type=style&index=0&id=3792d7ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3792d7ae"]])

export default __exports__